import { render } from "./PaginationArrowRight.vue?vue&type=template&id=bfca0f4a"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PaginationArrowRight.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bfca0f4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bfca0f4a', __exports__)) {
    api.reload('bfca0f4a', __exports__)
  }
  
  module.hot.accept("./PaginationArrowRight.vue?vue&type=template&id=bfca0f4a", () => {
    api.rerender('bfca0f4a', render)
  })

}


export default __exports__